var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": true,
        "modal-append-to-body": true,
        visible: _vm.dialogVisible,
        title: "新增特别说明",
        width: "60%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        { staticClass: "header-actions" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.openTemplateDialog },
            },
            [_vm._v(" 导入模板 ")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "editor-container" },
        [
          _c("Ueditor", {
            ref: "ueditor",
            attrs: { height: 400, parentId: 0 },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "left-actions" },
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.saveToTemplate,
                    callback: function ($$v) {
                      _vm.saveToTemplate = $$v
                    },
                    expression: "saveToTemplate",
                  },
                },
                [_vm._v(" 将该说明保存至公司模板库 ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "right-actions" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSave } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("import-template-dialog", {
        ref: "importTemplateDialog",
        attrs: { resourceId: _vm.resourceId },
        on: { "template-selected": _vm.handleTemplateSelected },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }